import { ManuteRequestConfig } from '@/api/types';
import { GroupRequest, RecipientRequest } from '@/api/requests/newsletter/mailup/types';

/**
 * Request to store a group in a list.
 * @param listId
 * @param group
 */
export const STORE = (listId: number, group: GroupRequest): ManuteRequestConfig => ({
    method: 'POST',
    url: `/newsletter/mailup/lists/${listId}/groups`,
    data: group,
    transformRequestKeysTo: 'PASCAL',
});

/**
 * Request to update a group in a list.
 * @param listId
 * @param groupId
 * @param group
 */
export const UPDATE = (listId: number, groupId: number, group: GroupRequest): ManuteRequestConfig => ({
    method: 'PUT',
    url: `/newsletter/mailup/lists/${listId}/groups/${groupId}`,
    data: group,
    transformRequestKeysTo: 'PASCAL',
});

/**
 * Request to destroy a group from a list.
 * @param listId
 * @param groupId
 */
export const DESTROY = (listId: number, groupId: number): ManuteRequestConfig => ({
    method: 'DELETE',
    url: `/newsletter/mailup/lists/${listId}/groups/${groupId}`,
});

/**
 * Request to find all recipients of a group by its id.
 * @param groupId
 */
export const GET_RECIPIENTS = (groupId: string | number): ManuteRequestConfig => ({
    method: 'GET',
    url: `/newsletter/mailup/groups/${groupId}/recipients`,
});

/**
 * Request to store a recipient in a group.
 * @param groupId
 * @param recipient
 * @param confirmEmail
 */
export const STORE_RECIPIENT = (
    groupId: string | number,
    recipient: RecipientRequest,
    confirmEmail: boolean = false): ManuteRequestConfig => ({
    method: 'POST',
    url: `/newsletter/mailup/groups/${groupId}/recipients/?confirmEmail=${confirmEmail}`,
    data: recipient,
    transformRequestKeysTo: 'PASCAL',
});

/**
 * Request to subscribe a recipient in a group.
 * @param groupId
 * @param recipientId
 */
export const SUBSCRIBE_RECIPIENT = (groupId: string | number, recipientId: string | number): ManuteRequestConfig => ({
    method: 'POST',
    url: `/newsletter/mailup/groups/${groupId}/recipients/${recipientId}/subscribe`,
});

/**
 * Request to unsubscribe a recipient from a group.
 * @param groupId
 * @param recipientId
 */
export const UNSUBSCRIBE_RECIPIENT = (groupId: string | number, recipientId: string | number): ManuteRequestConfig => ({
    method: 'DELETE',
    url: `/newsletter/mailup/groups/${groupId}/recipients/${recipientId}/unsubscribe`,
});
